

<script>
import ProductTemplateLimitedEducation3 from '@/components/templates/products/limited-education-2021-group3'

export default {
  name: 'ProductTemplateLimitedEducation4',

  mixins: [ProductTemplateLimitedEducation3],
  props: {
    title: {type: String, default: 'กาเป๋า ฮักตั๋วเน้อ'}
  },

  data () {
    return {
      itemCounts: [0, 0, 0, 0, 0, 0],
      itemPrices: [990, 990, 990, 990, 990, 990],
      itemInfos: [
        {name: 'ลาย Little Monster', value: 'กาเป๋า ฮักตั๋วเน้อ ลาย Little Monster'},
        {name: 'ลาย Note Udom', value: 'กาเป๋า ฮักตั๋วเน้อ ลาย Note Udom'},
        {name: 'ลาย Ken Seal', value: 'กาเป๋า ฮักตั๋วเน้อ ลาย Ken Seal'},
        {name: 'ลาย Wannasingh', value: 'กาเป๋า ฮักตั๋วเน้อ ลาย Wannasingh'},
        {name: 'ลาย Cherry', value: 'กาเป๋า ฮักตั๋วเน้อ ลาย Cherry'},
        {name: 'ลาย Tono', value: 'กาเป๋า ฮักตั๋วเน้อ ลาย Tono'}
      ],
      itemImages: [
        [
          {thumb: '/static/img/limited-edu/lmt-product-ad-01.jpg', large: '/static/img/limited-edu/shirt1_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-02.jpg', large: '/static/img/limited-edu/shirt2_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-03.jpg', large: '/static/img/limited-edu/shirt3_ad.png'}
        ],
        [
          {thumb: '/static/img/limited-edu/lmt-product-ad-01.jpg', large: '/static/img/limited-edu/shirt1_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-02.jpg', large: '/static/img/limited-edu/shirt2_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-03.jpg', large: '/static/img/limited-edu/shirt3_ad.png'}
        ],
        [
          {thumb: '/static/img/limited-edu/lmt-product-ad-01.jpg', large: '/static/img/limited-edu/shirt1_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-02.jpg', large: '/static/img/limited-edu/shirt2_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-03.jpg', large: '/static/img/limited-edu/shirt3_ad.png'}
        ],
        [
          {thumb: '/static/img/limited-edu/lmt-product-ad-01.jpg', large: '/static/img/limited-edu/shirt1_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-02.jpg', large: '/static/img/limited-edu/shirt2_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-03.jpg', large: '/static/img/limited-edu/shirt3_ad.png'}
        ],
        [
          {thumb: '/static/img/limited-edu/lmt-product-ad-01.jpg', large: '/static/img/limited-edu/shirt1_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-02.jpg', large: '/static/img/limited-edu/shirt2_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-03.jpg', large: '/static/img/limited-edu/shirt3_ad.png'}
        ],
        [
          {thumb: '/static/img/limited-edu/lmt-product-ad-01.jpg', large: '/static/img/limited-edu/shirt1_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-02.jpg', large: '/static/img/limited-edu/shirt2_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-03.jpg', large: '/static/img/limited-edu/shirt3_ad.png'}
        ]
      ],
      activeImages: [0, 0, 0, 0, 0, 0]
    }
  }
}
</script>



// WEBPACK FOOTER //
// limited-education-2021-group4.vue?0941902d